import { render, staticRenderFns } from "./shebao_weizhuanyi.vue?vue&type=template&id=75e65464&scoped=true"
import script from "./shebao_weizhuanyi.vue?vue&type=script&lang=js"
export * from "./shebao_weizhuanyi.vue?vue&type=script&lang=js"
import style0 from "./shebao_weizhuanyi.vue?vue&type=style&index=0&id=75e65464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e65464",
  null
  
)

export default component.exports